export const RESET_APP = 'RESET_APP'
export const SET_FUNDRAISER = 'SET_FUNDRAISER'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_VALUES = 'SET_VALUES'
export const CLEAR_VALUES = 'CLEAR_VALUES'
